<template>
  <Header />

  <div class="section container">
    <div class="content" v-if="!userCreated">
      <div class="heading">
        <h1>Add New Customer</h1>
      </div>

      <div class="form">
        <form @submit="submitEmail" v-if="this.step === 1">
          <div class="form-group">
            <label class="form-label">Email *
              <input v-model="customer.email" type="email" class="form-control" required>
            </label>
            <div class="buttons">
              <button type="submit" name="submit" class="btn btn--primary">
                Next
              </button>
            </div>
          </div>
          <div class="small-backend-error" v-if="userExists">
            <p>User with this email address already exists.</p>
          </div>
        </form>

        <CustomerContact
          :tier="customer.tier"
          :first-name="customer.first_name"
          :last-name="customer.last_name"
          :instagram-handle="customer.instagram_handle"
          :phone="customer.phone"
          :address1="customer.address1"
          :address2="customer.address2"
          :city="customer.city"
          :province="customer.province"
          :zip="customer.zip"
          :country="customer.country"
          :notification-preference="customer.notification_preference"
          :errorInfo="validationMessage"
          :creating-customer="true"

          button-text="Next"
          :show-tier="true"
          :show-notification="true"
          @contactFormSubmitted="updateCustomerContact"
          v-if="this.step === 2"
        />

        <CustomerSizing
          :tops="customer.tops"
          :bottoms="customer.bottoms"
          :fitted-hats="customer.fitted_hats"
          :footwear="customer.footwear"
          :accessories="customer.accessories"
          :tabs-open="true"

          button-text="Finish"
          @sizingFormSubmitted="updateCustomerSizing"
          v-if="this.step === 3"
        />

        <ul class="form-pagination">
          <li class="form-pagination__item" :class="{'form-pagination__item--active': this.step === 1 }" />
          <li class="form-pagination__item" :class="{'form-pagination__item--active': this.step === 2 }" />
          <li class="form-pagination__item" :class="{'form-pagination__item--active': this.step === 3 }" />
        </ul>
      </div>
    </div>
    <div class="content" v-if="userCreated">
      <div class="full-page-confirmation">
        <p>New customer added successfully!</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'

import Header from '../components/Header.vue';
import CustomerContact from '../components/CustomerContact.vue';
import CustomerSizing from '../components/CustomerSizing.vue';

export default {
  name: 'CreateCustomer',
  components: {
    Header, CustomerContact, CustomerSizing
  },
  data() {
    return {
      step: 1,
      customer: {},
      userExists: false,
      userCreated: false,
      validationMessage: '',
      errors: {
        first_name: false,
        last_name: false,
        phone: false,
        tier: false,
        address: false,
      },
    }
  },
  methods: {
    submitEmail(e) {
      e.preventDefault();

      const submitButton = e.target.elements.submit;
      submitButton.disabled = true;

      const customerEmail = this.customer.email;
      api.createCustomer(customerEmail).then(customer => {
        this.customer = customer;
        this.step = 2;
      }).catch(error => {
        if (error.data?.email && error.data.email[0] == "already taken") {
          this.userExists = true;
        } else {
          // some other validation errors
          console.error(error)
        }
      }).finally(() => {
        submitButton.disabled = false
      });
    },
    updateCustomerContact(contactAttributes, form) {
      const submitButton = form.elements.submit;
      submitButton.disabled = true;

      api.updateCustomer(this.customer.id, contactAttributes).then(customer => {
        this.validationMessage = '';
        this.customer = customer;
        this.message = "Settings saved successfully!"
        this.step = 3;
      }).catch(error => {
        this.validationMessage = error.data || error.message;
      }).then(() => {
        submitButton.disabled = false
      });
    },
    updateCustomerSizing(sizingAttributes, form) {
      const submitButton = form.elements.submit;
      // submitButton.disabled = true;

      console.log(sizingAttributes);

      var newSizingAttributes = {
        tops: sizingAttributes.tops,
        bottoms: sizingAttributes.bottoms,
        fitted_hats: sizingAttributes.fitted_hats,
        footwear: sizingAttributes.footwear,
        accessories: sizingAttributes.accessories,
        tops_sizes_confirmed: sizingAttributes.topsConfirmed,
        bottoms_sizes_confirmed: sizingAttributes.bottomsConfirmed,
        footwear_sizes_confirmed: sizingAttributes.footwearConfirmed,
        headwear_sizes_confirmed: sizingAttributes.headwearConfirmed,
        accessories_sizes_confirmed: sizingAttributes.accessoriesConfirmed
      }

      api.updateCustomer(this.customer.id, newSizingAttributes).then(customer => {
        this.customer = customer;
        this.message = "Settings saved successfully!"
        // alert(this.message)
        this.userCreated = true;

        setTimeout(this.redirectToUser, 3000);
      }).catch(errors => {
        console.error(errors);
      }).then(() => {
        submitButton.disabled = false
      });
    },
    redirectToUser() {
      this.$router.push('/customer/'+this.customer.id);//this.$router.push(`/customer/${customerId}`);
    }
  }
}
</script>
